import React, { useState } from 'react';
import { Button } from "antd";
import { AuthPageContainer } from '../Register/AuthPageContainer';
import { isValid } from '../../utils/Validation';
import { AuthLogo } from './ClinicLogo';
import { otpErrorText } from './constants';
import { useIsMounted } from './useIsMounted';

export const IdentificationStep = ({ clinicLogoUrl, govId, onGovIdChange, onSubmit }) => {
    // Validation shows only after the field loses focus, per spec.
    const [touched, setTouched] = useState(false);
    const [sending, setSending] = useState(false);
    const isMounted = useIsMounted();
    const [serverError, setServerError] = useState(null);

    const error = isValid(govId, "israeliId", touched);
    const showError = touched && error !== "";

    const submit = async () => {
        if (sending || error !== "" || govId === "") {
            return;
        }

        setSending(true);
        setServerError(null);

        const outcome = await onSubmit();
        if (!isMounted()) {
            return;
        }

        setSending(false);
        if (!outcome.ok && !outcome.handled) {
            setServerError(otpErrorText(outcome.result));
        }
    }

    return (
        <AuthPageContainer className={'recordAuth'} logo={<AuthLogo url={clinicLogoUrl} />} header={'כניסה עם קוד חד-פעמי לרשומה הרפואית'}>
            <div className={"authInputContainer"}>
                <div className={"inputContainer"}>
                    <label className={"inputLabel" + (showError || serverError ? " recordInputError" : "")} htmlFor="govId">
                        <input
                            id="govId"
                            autoComplete="off"
                            inputMode="numeric"
                            placeholder={'ת.ז'}
                            value={govId}
                            onChange={(e) => {
                                setServerError(null);
                                onGovIdChange(e.target.value.replace(/\D/g, ''));
                            }}
                            onBlur={() => setTouched(true)}
                            maxLength={9} />
                    </label>
                </div>
                {showError && <div className={"recordErrorText"}>{error}</div>}
                {!showError && serverError && <div className={"recordErrorText"}>{serverError}</div>}
            </div>
            <Button
                type={"primary"}
                block
                loading={sending}
                disabled={govId === "" || error !== ""}
                onClick={submit}>
                שלחו לי קוד לכניסה
            </Button>
        </AuthPageContainer>
    );
}
